export const FETCH_INIT_CHART = 'chart/FETCH_INIT_CHART';
export const FETCH_BEFORE_CHART = 'chart/FETCH_BEFORE_CHART';
export const FETCH_LOOKBACK_CHART = 'chart/FETCH_LOOKBACK_CHART';

export const SET_INIT_CHART = 'chart/SET_INIT_CHART';
export const SET_BEFORE_CHART = 'chart/SET_BEFORE_CHART';

export const SET_INDEX_CHART = 'chart/SET_INDEX_CHART';
export const SET_SYMBOL_CHART = 'chart/SET_SYMBOL_CHART';
